var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7502 18.1144V18.1096C21.7502 18.1096 17.5818 13.9461 17.5793 13.9441C17.2488 13.6134 16.7203 13.6206 16.3951 13.9463L14.4765 15.8729C13.7306 16.6189 12.7688 15.9569 10.9226 14.4515C9.7011 13.4555 8.29573 12.1161 7.0772 10.6061C6.22205 9.54664 5.46585 8.43403 6.24707 7.653C6.24909 7.65098 8.17362 5.73141 8.17325 5.72939L8.17472 5.72535C8.52009 5.37998 8.48662 4.85089 8.17123 4.53513V4.53035C8.17123 4.53035 3.88246 0.246918 3.88007 0.244344C3.5496 -0.0861274 3.02125 -0.0787713 2.69593 0.246551L0.763121 2.17936C-0.0331728 3.17592 -1.80286 7.92554 5.784 15.7024C13.7764 23.8954 18.9337 22.1428 19.8216 21.2183C19.8216 21.2183 21.7524 19.3103 21.7524 19.3085L21.754 19.3046C22.0994 18.9591 22.0654 18.4304 21.7502 18.1144Z",
    fill: "#F68D10"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.8a02d84591e79fa60ba723dedc6523f2.svg";
export { ForwardRef as ReactComponent };